class AnnouncementBar extends HTMLElement {
	constructor() {
		super();

		if (document.body.hasAttribute("swiper-loaded")) {
			this.initSlider();
		} else {
			document.addEventListener('swiper-loaded', (event) => {
				this.initSlider();
			});
		}
	}

	initSlider() {
		const swiper = new Swiper(this.querySelector('.swiper_container'), {
			slidesPerView: 1,
			spaceBetween: 15,
			loop: true,
			direction: 'vertical',
			autoplay: {
				pauseOnMouseEnter: true
			}
		});
	}
}

customElements.define("announcement-bar", AnnouncementBar);